/**
 * The mockup's `.tile` — the square glyph plate a screen leads with when it has no form to lead
 * with: the mail plate on the confirmation screen (screen 5) and the accent plate on the
 * trainer-only refusal (screen 7).
 *
 * Promoted here on its second consumer, not its first. `tone` exists because the mockup draws both
 * states, not as a seam invented for a variation nobody asked for: neutral is a plain surface, and
 * accent is the screen's ONE accent use — the other is the focus ring.
 *
 * The glyph is decorative in both cases, so the tile is `aria-hidden` as a whole. The heading right
 * beneath it says what the screen is; announcing an unlabelled square first would only add noise.
 */

import type { ReactNode } from 'react';

import styles from './AuthTile.module.css';

interface AuthTileProps {
  /** A glyph from `AuthIcons`, rendered with the tile's own icon class. */
  icon: (props: { className?: string }) => ReactNode;
  tone?: 'neutral' | 'accent';
}

export function AuthTile({ icon: Icon, tone = 'neutral' }: AuthTileProps) {
  return (
    <div
      className={`${styles.tile} ${tone === 'accent' ? styles.accent : ''}`}
      aria-hidden="true"
    >
      <Icon className={styles.icon} />
    </div>
  );
}
